import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PdfBottomBlockComponent } from './pdf-bottom-block.component';
import { LogoModule } from 'common/src/modules/ui-components/logo/logo.module';


@NgModule({
  declarations: [
    PdfBottomBlockComponent
  ],
  exports: [
    PdfBottomBlockComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    LogoModule
  ],
  providers: []
})
export class PdfBottomBlockModule { }
